import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import AthletesList from '../AthletesList';
import AthletesSummary from '../AthletesSummary';
import classNames from 'classnames/bind';
import constants from '../../constants';
import { teamPropTypes, athletePropTypes } from '../../hooks/UseAppContext';
import AppContext from '../../context/AppContext';

import styles from './TeamItem.module.scss';

function TeamItem({ team }) {
  const cx = classNames.bind(styles);
  const { handleModal } = useContext(AppContext);
  const { handleBannerCartola } = useContext(AppContext);
  const [renderedAthletes, setRenderedAthletes] = useState(false);
  const savedEvaluation = window.localStorage.getItem(
    `avaliacoes ${team.name}`
  );
  const [evaluation, setEvaluation] = useState(
    savedEvaluation ? JSON.parse(savedEvaluation) : {}
  );
  const [open, setOpen] = useState(false);
  const [tabSummary, setTabSummary] = useState(0);

  const handleCartolaBanner = (teamModal, teamName) => {
    const { handleOpenBannerCartola } = handleBannerCartola;
    if (handleOpenBannerCartola) {
      handleOpenBannerCartola(teamModal, teamName);
    }
  };

  const handleClick = (event) => {
    setRenderedAthletes(true);
    setOpen(!open);
    const teamClicked = event.currentTarget.id;
    const teamName = event.currentTarget.value;

    if (!open) {
      handleCartolaBanner(teamClicked, teamName);
    }
  };

  const handleTabClick = (value) => {
    setTabSummary(value);
  };

  const handleEvaluation = (athleteId, value) => {
    const response = {
      ...evaluation,
      [athleteId]: value,
    };

    window.localStorage.setItem(
      `avaliacoes ${team.name}`,
      JSON.stringify(response)
    );

    setEvaluation({ ...response });
  };

  const handleOpenModal = () => {
    const { handleOpenShare } = handleModal;
    if (handleOpenShare) {
      const response = { ...team };
      response.athletes = [...team.athletes]
        .filter((item) => evaluation[item.id])
        .map((item) => ({ ...item, eval: evaluation[item.id] }));
      handleOpenShare(response);
    }
  };

  const levels = {};
  team.athletes.forEach((athlete) => {
    if (!levels[athlete.eval]) levels[athlete.eval] = 0;
    levels[athlete.eval] = levels[athlete.eval] + 1;
  });

  return (
    <li
      className={cx({
        wrapper: true,
        wrapperOpen: open,
      })}
    >
      <button
        type="button"
        id={team.slug}
        value={team.name}
        className={styles.button}
        onClick={handleClick}
      >
        <figure className={styles.figure}>
          <div className={styles.flag}>
            <img
              className={styles.image}
              src={team.emblem}
              title={team.name}
              alt={team.name}
            />
          </div>
          <figcaption className={styles.caption}>
            <div className={styles.text}>
              <div className={styles.name}>{team.name}</div>
              <div className={styles.total}>{team.total}</div>
            </div>
            <div className={styles.bars}>
              {Object.keys(levels)
                .sort((a, b) => b - a)
                .map((key, index) => {
                  const value = levels[key];
                  return (
                    <div
                      key={`Bar__key__${team.id}__${index}`}
                      className={cx(['level', `level${key}`])}
                      style={{
                        width: `${100 * (value / team.athletes.length)}%`,
                      }}
                    />
                  );
                })}
            </div>
          </figcaption>
          <div
            className={cx({
              arrow: true,
              arrowOpen: open,
            })}
          />
        </figure>
      </button>
      {renderedAthletes && (
        <>
          <AthletesList
            athletes={team.athletes}
            evaluation={evaluation}
            handleEvaluation={handleEvaluation}
          />
          <AthletesSummary
            athletes={team.athletes}
            evaluation={evaluation}
            tab={tabSummary}
            handleTabChange={handleTabClick}
          />
          <div className={styles.shareWrapper}>
            <button
              className={cx({
                share: true,
                shareDisabled: Object.keys(evaluation).length === 0,
              })}
              type="button"
              onClick={handleOpenModal}
              disabled={Object.keys(evaluation).length === 0}
            >
              {constants.share.text}
            </button>
          </div>
        </>
      )}
    </li>
  );
}

TeamItem.propTypes = {
  ...teamPropTypes,
  athletes: PropTypes.arrayOf(
    PropTypes.shape({ ...athletePropTypes }).isRequired
  ),
  total: PropTypes.number.isRequired,
};

TeamItem.defaultProps = {
  id: 0,
  name: '',
  emoji: '',
  abbr: '',
  slug: '',
  gender: '',
  emblem: '',
  athletes: [],
  total: 0,
};

export default TeamItem;
